import { createContext, useContext, useState } from "react";

// Create Context
const MFBottlerSelectionContext = createContext();

// Context Provider Component
export const MFBottlerSelectionProvider = ({ children }) => {
    const [selectedData, setSelectedData] = useState([]);

    return (
        <MFBottlerSelectionContext.Provider value={{ selectedData, setSelectedData }}>
            {children}
        </MFBottlerSelectionContext.Provider>
    );
};

// Custom Hook for easy access
export const useMFBottlerSelection = () => useContext(MFBottlerSelectionContext);
